import { Constants } from '../../util/Constants';
import { Directive } from '@angular/core';
import { Validators, AbstractControl, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { RestService } from '../../services/restService';
import { CustomStorageProvider } from '../../providers/custom-storage/custom-storage';

/**
 * Generated class for the NicknameExistsValidatorDirective directive.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/DirectiveMetadata-class.html
 * for more info on Angular Directives.
 */

@Directive({
  selector: '[nickname-exists-validator]',
  providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: NicknameExistsValidatorDirective, multi: true }]
})
export class NicknameExistsValidatorDirective implements Validators {

  constructor(private restService: RestService, private customStorageProvider: CustomStorageProvider) {

  }

  validate(ctrl: AbstractControl): Promise<any> {

    return new Promise((resolve, reject) => {
      let originalNickname = this.customStorageProvider.get<string>(Constants.STORAGE_KEY_NICKNAME);
      if (originalNickname == ctrl.value || ctrl.value == "") {
        resolve(null);
      } else {
        this.restService.checkNameAvailable(ctrl.value).then(response => {
          if (response.result) {
            resolve(null);
          } else {
            resolve({ "nicknameExists": true });
          }
        },
          err => {
            resolve({ "nicknameExists": true });
          })
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/directives/nickname-exists-validator/nickname-exists-validator.ts